import styled from '../../../utils/styling/styled';

import styleUtils from '../../../utils/styling/styleUtils';

export const Address = styled.address`
  ${styleUtils.margin.vertical.bothHalf};

  color: ${props => props.theme.color.white};
`;
